"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { basePath } from "@/lib/basePath";

interface AvailabilityResult {
  slug: string;
  available: boolean;
}

export default function WordVideoLink({ slug }: { slug: string }) {
  const [result, setResult] = useState<AvailabilityResult>({
    slug,
    available: false,
  });

  useEffect(() => {
    const controller = new AbortController();
    // Hide availability from the previous slug before starting this request.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setResult({ slug, available: false });

    fetch(`${basePath}/api/words/${encodeURIComponent(slug)}/video`, {
      signal: controller.signal,
      cache: "no-store",
    })
      .then(async (response) => {
        if (!response.ok) return;
        const data: unknown = await response.json();
        if (!controller.signal.aborted) {
          const available = typeof data === "object"
            && data !== null
            && "available" in data
            && data.available === true;
          setResult({ slug, available });
        }
      })
      .catch((error: unknown) => {
        const wasAborted = controller.signal.aborted
          || (error instanceof DOMException && error.name === "AbortError");
        if (wasAborted) return;
        console.error("Word video availability request failed");
      });

    return () => controller.abort();
  }, [slug]);

  if (result.slug !== slug || !result.available) return null;

  return (
    <Link
      href={`/words/${encodeURIComponent(slug)}/video`}
      prefetch={false}
      className="mt-4 inline-flex items-center rounded-full border border-amber-300 bg-white px-4 py-2 text-sm font-semibold text-amber-800 shadow-sm transition-colors hover:border-amber-400 hover:bg-amber-100"
    >
      觀看單字影片
    </Link>
  );
}
